
export default {
    props: {
        guest: {
            type: Object,
            default: () => {
                return {}
            },
        },

        event: {
            type: Object,
            default: () => {
                return {}
            },
        },
    },

    computed: {
        getEventPlusOnes() {
            return this.event.status === 3 && this.guest.children?.length
                ? this.guest.children.filter((gst) => gst.wedding_events?.findIndex((ev) => ev.id === this.event.id && [1, 2, 3].includes(ev.status)) !== -1)
                : []
        },

        answers() {
            let answers = null
            try {
                answers = JSON.parse(this.event.answers)
            } catch (error) {
                answers = this.event?.answers?.length ? answers : []
            }
            return answers?.length ? answers.filter((el) => el.answer) : []
        },
    },
}
